import { useEffect } from "react";

// Cuántos componentes están pidiendo el bloqueo. Sin el contador, cerrar un
// modal mientras otro sigue abierto (por ejemplo el alert que aparece al
// guardar, que se monta antes de que el form termine de cerrarse) devolvería
// el scroll de fondo antes de tiempo.
let locks = 0;

let previousStyles = null;

/**
 * Bloquea el scroll del `body` mientras `locked` sea true. Se usa desde los
 * modales: sin esto la rueda del mouse scrollea la página de atrás en vez del
 * contenido del modal.
 */
export default function useScrollLock(locked) {
  useEffect(() => {
    if (!locked) {
      return;
    }

    const { body } = document;

    if (locks === 0) {
      // Al ocultar el scroll desaparece la barra y el contenido de fondo salta
      // unos px hacia la derecha: lo compensamos con padding.
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      previousStyles = {
        overflow: body.style.overflow,
        paddingRight: body.style.paddingRight,
      };

      body.style.overflow = "hidden";

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    locks += 1;

    return () => {
      locks -= 1;

      if (locks === 0 && previousStyles) {
        body.style.overflow = previousStyles.overflow;
        body.style.paddingRight = previousStyles.paddingRight;

        previousStyles = null;
      }
    };
  }, [locked]);
}
